module.exports = __webpack_public_path__ + "static/media/ccs-objects.ec758472.jpg";